import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@app/auth';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';

@Component({
  selector: 'app-contact-dtm-dialog',
  templateUrl: './contact-dtm-dialog.component.html',
  styleUrls: ['./contact-dtm-dialog.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: [
        'prices',
        'global',
        'register',
        'settings',
        'process_form',
        'model_geometry',
        'model_realEstate',
        'realestates',
        'model_complexity',
        'model_quality',
      ],
    },
  ],
})
export class ContactDtmDialogComponent implements OnInit {
  modul: any;
  constructor(
    private dialogRef: MatDialogRef<ContactDtmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public modulObj: any,
  ) {
    this.modul = this.modulObj.modul.modul ? this.modulObj.modul.modul.toUpperCase() : '';
  }

  ngOnInit(): void {}

  clear() {
    this.dialogRef.close({
      response: 'OK',
    });
  }
}
